import { render, staticRenderFns } from "./m-table.vue?vue&type=template&id=2995c844"
import script from "./m-table.vue?vue&type=script&lang=js"
export * from "./m-table.vue?vue&type=script&lang=js"
import style0 from "./m-table.vue?vue&type=style&index=0&id=2995c844&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports